import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { getFormattedUserTimeZone } from '@/common/utils/utils';

dayjs.extend(utc);
dayjs.extend(timezone);

export interface TimeFormatResult {
  relative: string;
  full: string;
}

/**
 * Formats timestamp into relative time ("2 hrs ago") and full format ("10/23/25 at 1:53 PM CDT")
 */
export const callEmailTimeFormatted = (
  ts: string,
  isTimeZone = true,
  dateFormat?: string | null
): TimeFormatResult => {
  if (!ts) {
    return { relative: '---', full: '---' };
  }

  const tzString = getFormattedUserTimeZone();
  const match = tzString.match(/ ([A-Za-z_/]+)$/);
  const userTz = match ? match[1] : dayjs.tz.guess();

  const now = isTimeZone ? dayjs().tz(userTz) : dayjs();
  const created = isTimeZone
    ? dayjs.tz(ts, 'YYYY-MM-DD HH:mm:ss', userTz)
    : dayjs(ts, 'YYYY-MM-DD HH:mm:ss');

  const msDiff = now.diff(created);
  const seconds = Math.floor(msDiff / 1000);
  const minutes = Math.floor(msDiff / (60 * 1000));
  const hours = Math.floor(msDiff / (60 * 60 * 1000));
  const days = Math.floor(msDiff / (24 * 60 * 60 * 1000));

  let relative: string;
  if (seconds < 60) relative = 'Now';
  else if (minutes < 60) relative = `${minutes} m ago`;
  else if (hours < 24) relative = `${hours} hrs ago`;
  else relative = `${days} days ago`;

  const tzAbbr = created.format('z');
  const datePart = dateFormat === 'DD/MM/YYYY' ? 'DD/MM/YY' : 'MM/DD/YY';
  const full = `${created.format(`${datePart} [at] h:mm A`)} ${tzAbbr}`;

  return { relative, full };
};
